import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import TaskIcon from '@mui/icons-material/Task';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import ApplicationStore from '../../../utils/localStorageUtil';
import AddIcon from '@mui/icons-material/Add';
import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import PrintIcon from '@mui/icons-material/Print';
import ReactDOMServer from "react-dom/server";
import axios from '../../../api/axios';
import PDFPrint from './PDFPrint';
import htmlToPdfmake from "html-to-pdfmake";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
const URL = "./dealership/getClosed";

function ViewClosedWarranty() {
    const user = ApplicationStore().getStorage('user_email');
    const [state, setState] = useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });


    const navigate = useNavigate();

    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({ ...state, [anchor]: open });
    };

    const columns = [
        { field: 'slNo', headerName: 'ID', width: 50 },
        { field: "customerFirstName", headerName: "Customer Name", width: 200 },
        { field: "vinNo", headerName: "Vin No", width: 200 },
        { field: "make", headerName: "Selected Vehicle", width: 200 },
        { field: "packagesText", headerName: "Package Type", width: 200 },

        {
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            width: 250,
            cellClassName: 'actions',
            getActions: (params) => {
                return [
                    // <EditData selectedRow={params.row}/>,
                    // <DeleteData selectedRow={params.row} />,                        
                    // <Block selectedRow={params.row} />
                    // <EditData selectedRow={params.row} />,
                    // <DeleteData selectedRow={params.row} />,
                    <PrintData selectedRow={params.row} />
                ];
            }
        },
    ];

    const PDFPrintNew = ({ data }) => {
        return (
            <div style={{ width: "100%" }}>
                <table
                    style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        tableLayout: "fixed", // Ensure fixed table layout for equal width
                    }}
                >
                    <tr>
                        <td rowSpan="6" style={{ border: "1px solid black", width: "50%" }}>
                            First Column Spanning Rows
                        </td>
                        <td style={{ border: "1px solid black", width: "50%" }}>
                            Application ID: 2409136013
                        </td>
                    </tr>
                    <tr>
                        <td style={{ border: "1px solid black" }}>Application ID: 2409136013</td>
                    </tr>
                    <tr>
                        <td style={{ border: "1px solid black" }}>Application ID: 2409136013</td>
                    </tr>
                    <tr>
                        <td style={{ border: "1px solid black" }}>Application ID: 2409136013</td>
                    </tr>
                    <tr>
                        <td style={{ border: "1px solid black" }}>Application ID: 2409136013</td>
                    </tr>
                    <tr>
                        <td style={{ border: "1px solid black" }}>Application ID: 2409136013</td>
                    </tr>
                </table>
            </div>
        )
    }

   const generatePdf = (data) => {
        console.log("data" + JSON.stringify(data));
        // Render the PDFPrint component as static HTML
        const componentHtml = ReactDOMServer.renderToStaticMarkup(<PDFPrintNew />);

        // Convert the HTML content to pdfMake format
        const pdfContent = htmlToPdfmake(componentHtml, { window });

        // Create the PDF document definition using the converted content
        const docDefinition = {
            pageSize: 'A4',
            pageMargins: [20, 20, 20, 20],
            content: [
                // First Table
                {
                    table: {
                        widths: ['50%', '50%'], // Set the width for each column
                        body: [
                            [
                                { text: 'Image', rowSpan: 3, border: [false, false, false, false] },
                                { text: `Application ID: ${data.id}`, border: [false, false, false, false] }
                            ],
                            ['', { text: `Warranty Status: ${data.Status}`, border: [false, false, false, false] }],
                            ['', { text: `GAP Bundle Warranty Price: ${data.warrantySoldFor}`, border: [false, false, false, false] }],
                            [
                                { text: 'Application for GAP Bundle Warranty Coverage', rowSpan: 3, border: [false, false, false, false] },
                                { text: `220 Duncan Mill Road, Suite 407,Toronto, Ontario, M3B 3J5 Phone:905.709.0927 | (F) 800.358.7902`, border: [false, false, false, false] }
                            ],

                            ['', { text: 'WWW.guaranteevc.ca', border: [false, false, false, false] }],
                            ['', { text: 'info@guaranteevc.ca', border: [false, false, false, false] }]
                        ]
                    }
                },
                {
                    table: {
                        widths: ['50%', '50%'], // Adjust the column widths for this table
                        body: [
                            [
                                { text: 'Customer details', border: [false, false, false, false] },
                                { text: '', border: [false, false, false, false] }
                            ],
                            [
                                { text: `Customer First Name: ${data.customerFirstNameText}`, border: [true, true, true, true] },
                                { text: `Address: ${data.streetAddressText}`, border: [true, true, true, true] }
                            ],
                            [
                                { text: `Customer Last Name: ${data.customerLastNameText}`, border: [true, true, true, true] },
                                { text: '', border: [true, true, true, true] }
                            ],
                            [
                                { text: `Drivers Licence:  ${data.driverLicenceText}`, border: [true, true, true, true] },
                                { text: `Email: ${data.customerEmailText}`, border: [true, true, true, true] }
                            ],
                            [
                                { text: `Phone: ${data.customerPhoneText} `, border: [true, true, true, true] },
                                { text: ``, border: [true, true, true, true] }
                            ]
                        ]
                    }
                },
                { text: '\n' }, // Add spacing between the tables

                // Second Table
                {
                    table: {
                        widths: ['50%', '50%'], // Adjust the column widths for this table
                        body: [
                            [
                                { text: 'Vehicle Information', border: [false, false, false, false] },
                                { text: '', border: [false, false, false, false] }
                            ],
                            [
                                { text: `Year: ${data.yearText}`, border: [true, true, true, true] },
                                { text: `Sale Price: ${data.salePriceofVehicleText}`, border: [true, true, true, true] }
                            ],
                            [
                                { text: `Make: ${data.makeText}`, border: [true, true, true, true] },
                                { text: '', border: [true, true, true, true] }
                            ],
                            [
                                { text: `Model:  ${data.modelText}`, border: [true, true, true, true] },
                                { text: `Vehicle Delivery Date: ${data.vehicleDeliveryDate}`, border: [true, true, true, true] }
                            ],
                            [
                                { text: `VIN: ${data.vinNoText} `, border: [true, true, true, true] },
                                { text: `In Service Date:${data.serviceDateText}`, border: [true, true, true, true] }
                            ],
                            [
                                { text: `Odometer: ${data.odometerText} `, border: [true, true, true, true] },
                                { text: `Finance Company:${data.financeCompanyText}`, border: [true, true, true, true] }
                            ],

                        ]
                    }
                },

                { text: '\n' }, // Add spacing between the tables

                // Third Table

                // Second Table
                {
                    table: {
                        widths: ['50%', '50%'], // Adjust the column widths for this table
                        body: [
                            [
                                { text: 'Warranty Details', border: [false, false, false, false] },
                                { text: '', border: [false, false, false, false] }
                            ],
                            [
                                { text: `Warranty Plan: ${data.productName}`, border: [true, true, true, true] },
                                { text: `Deductible: ${data.deductible}`, border: [true, true, true, true] }
                            ],

                            [
                                { text: `Max Protection:  ${data.modelText}`, border: [true, true, true, true] },
                                { text: `Roadside: None`, border: [true, true, true, true] }
                            ],
                            [
                                { text: `Warranty Length: ${data.vinNoText} `, border: [true, true, true, true] },
                                { text: ``, border: [true, true, true, true] }
                            ],
                            [
                                { text: `High Ratio Coverage: ${data.highRatioCoverageText} `, border: [true, true, true, true] },
                                { text: ``, border: [true, true, true, true] }
                            ],

                        ]
                    }
                },

                { text: '\n' }, // Add spacing between the tables

                {
                    text: 'Terms & Conditions', // Heading
                    style: { fontSize: 16, bold: true, margin: [0, 10, 0, 10] }, // Style for the heading
                },


                {
                    text: [
                        { text: '• I, the Buyer, have read, selected, understand, and accept the terms and conditions of the Warranty Application and the Warranty Policy as outlined in the following pages and have retained a copy of the application and acknowledge that the selling dealer has made no representation outside the Terms and Conditions.\n', margin: [0, 5] },
                        { text: '• I, understand and agree that it is my obligation to maintain the vehicle according to the manufacturer\'s guidelines.\n', margin: [0, 5] },
                        { text: '• I understand any abuse, misuse, or neglect of my vehicle may lead to my claims being denied.\n', margin: [0, 5] },
                        { text: '• I understand repairs made to covered components without prior authorization by Guarantee VC will not be reimbursed.\n', margin: [0, 5] },
                        { text: '• I hereby certify that all of the information set out herein is true and accurate, I am applying for coverage at the time of the vehicle purchase and the vehicle is in proper condition at the date of the application. Misleading or False Information will void warranty coverage.\n', margin: [0, 5] }
                    ],
                    border: [true, true, true, true]
                },

                {
                    text: 'Terms and Conditions',
                    style: { fontSize: 16, bold: true, margin: [0, 10, 0, 10] },
                },
                {
                    text: "This Warranty Agreement & Financial GAP Bundle, including this Warranty Holder Registration Page and the attached Terms and Conditions make up the entire Warranty Agreement (“the Agreement”). No other documents, unless provided directly to you as the warranty holder from Guarantee VC are legal and binding. Please retain a copy of this Warranty Agreement to evidence your coverage. Please note that only the parts, labour and benefits listed within this Agreement are covered by this Agreement.",
                    margin: [0, 0, 0, 10],
                },
                {
                    text: 'Part I: FINANCE GAP PROTECTION BUNDLE',
                    style: { fontSize: 14, bold: true, margin: [0, 10, 0, 5] },
                },
                {
                    text: 'GAP: TOTAL LOSS ACCIDENT PROTECTION',
                    style: { fontSize: 14, bold: true, margin: [0, 5, 0, 5] },
                },
                {
                    text: [
                        { text: '1. Maximum Liability Amounts:\n', bold: true },
                        'The Maximum Liability amount is indicated on the first page of this Warranty Agreement.\n',
                        'Option A: $7,500 or 150% of the retail value of the vehicle at the time of loss, whichever is less.\n',
                        'Option B: $25,000 or 150% of the retail value of the vehicle at the time of loss, whichever is less.\n',
                        'If the Finance GAP Protection Bundle is chosen, and is indicated on the first page of this Warranty Agreement, a claim can be made in two cases:\n',
                        'i.) The Covered Vehicle is declared a Total Loss, due to any accidental physical damage, by the warranty holder’s primary insurance company;\n',
                        'ii.) The Covered Vehicle is declared a Total Loss, in the case where the Covered Vehicle is stolen and not recovered within 120 days, or is recovered within 120 days but is damaged to the extent it is considered a Total Loss.\n',
                        'In these cases, Guarantee VC will reimburse the Warranty Agreement holder up to the Maximum Liability Limit chosen, less any Deductible applied to this Warranty Agreement, for the shortfall between the outstanding Fixed Loan Balance at the time of the Settlement of The Total Loss excluding taxes & miscellaneous fees, and the amount paid by the primary insurance company, after the covered vehicle is deemed a total loss, up to the Maximum Liability indicated on the first page of this Agreement as defined above.\n',
                        'The original Fixed Loan Amount cannot exceed 150% of the retail Black Book Value of the vehicle, at the time of the sale, to the Maximum amount referenced above. Any original Fixed Loan Amount that exceeds this will mitigate any claim payment under this clause in a proportional manner.\n',
                        'Any changes to the original fixed loan agreement may exclude or mitigate any claim payment under this clause.\n',
                        'This benefit is available to the original warranty holder only and is not transferable or refundable; a claim paid under this clause will terminate this contract in full.\n',
                        'If the Agreement Holder has other insurance, warranty or guarantee, which applies to a loss or claim, or would have applied in this Warranty Agreement did not exist, this Warranty Agreement will be considered excess coverage and will not pay any loss or claims until the amount of such other coverage is exhausted.\n',
                        'To make a claim the following must be submitted to Guarantee VC: Original copies of the police report, filed within 30 days from the date of the loss; Original copies of the insurance claim report, filed within 30 days from the date of the loss; Original copies of proof of payment by the primary insurance company; Guarantee VC reserves the right to obtain original copies of any and all other supporting documents, as they may be required in our sole discretion to verify the claim. Time is of the essence: Guarantee VC must be informed of any claims within 30 days of any loss.\n'
                    ],
                    margin: [0, 0, 0, 10],
                },
                {
                    text: '2. OPTIONAL COVERAGE:\n',
                    bold: true,
                },
                {
                    text: [
                        'HIGH RATIO COVERAGE: If the option is indicated on the first page of this agreement the 150% Cap on the Total Loss Accident Protection can be increased by up to $7500. This option does not increase the chosen Total Maximum Liability of $7500 or $25000.\n',
                        '3. LOYALTY CREDIT:\n',
                        'In addition to the benefits described above, We will pay you a benefit of $500 if: a) within 30 days following a Total Loss, you purchase a new or used vehicle from the dealer from whom the Insured Vehicle was purchased; and b) the dealer lists the credit in the bill of sale agreement for the replacement vehicle; and c) you or the dealer provides us with a copy of the bill of sale and a letter applying for the credit within 15 days of the bill of sale.\n',
                        '4. GAP: PARTIAL LOSS COLLISION DEDUCTIBLE PROTECTION:\n',
                        'In addition to the benefits detailed above, in the event that the warranty holder and the covered vehicle is involved in a Partial Loss at fault accident, Guarantee VC will reimburse the warranty holder, less the deductible indicated on the first page of this contract, the Auto Collision deductible applied by the warranty holder’s primary insurance provider up to a maximum of $1000.00. The warranty holder may qualify to make a claim under this option only once under this Warranty Agreement. This benefit is available to the original warranty holder only, and is not transferable. To submit a claim the following must be submitted to Guarantee VC: Original copy of the police report, filed within 30 days from the date of the loss; Original copy of the insurance claim report, filed within 30 days from the date of the loss; Original copy of proof of payment by primary insurance company; Guarantee VC reserves the right to obtain original copies of any and all other supporting documents, as they may be required in our sole discretion to verify the claim. Time is of the essence: Guarantee VC must be informed of any claims within 30 days of any loss.\n'
                    ],
                    margin: [0, 0, 0, 10],
                },
                {
                    text: 'Part II: MECHANICAL BREAKDOWN',
                    style: 'header',
                    margin: [0, 10, 0, 5],
                },
                {
                    ul: [
                        { text: 'Term: 30 Days from Initiation Date.', margin: [0, 5] },
                        { text: 'Maximum Liability: $1000 Per Claim.', margin: [0, 5] },
                        { text: 'Deductible: $500 Per Claim.', margin: [0, 5] },
                    ],
                },
                {
                    text: '1. This Part pertains to mechanical breakdowns, and is not a service agreement. As part of Your Financial GAP Bundle and subject to the Terms and Conditions as contained herein, Guarantee VC (the “Administrator”) warrants that it will repair the Registered Owner’s vehicle (“Warranty Holder”) and all reasonable costs incurred as denoted as covered by this Agreement during the term of the warranty offered under this Agreement, when a Mechanical Failure or Breakdown has occurred. For the purposes of this Agreement, a Breakdown or Mechanical Failure for the purposes of this Agreement shall mean: the failure of a Covered Part under normal service. A Covered Part has failed when it can no longer perform the function for which it was designed solely because of its condition and not because of the action or inaction of any non-Covered Part. Only the parts and labour described below as covered (“Covered Part”) are covered by this Agreement in the event of a Mechanical Failure or a Breakdown. Coverage under this Agreement can only be applied for in two cases, i) at the time of the sale or lease of the covered vehicle, as applicable to the covered vehicle, being the vehicle identified on the front page of this Agreement (the “Covered Vehicle”), ii) at a point in time prior to the expiration of an existing original Manufacturer’s Warranty. In the case of purchase under the terms of (ii) herein, the coverage purchased under this Agreement must have equal or lesser coverage than the expiring manufacturer warranty. The obligations of Guarantee VC shall commence immediately or when an existing factory warranty expires, as applicable to the timing of the purchase of this Agreement. The obligations of Guarantee VC shall expire according to the length of term indicated on the front page of this Agreement, based on the earlier of Agreement term length or odometer reading, whichever occurs first. Coverage of the Covered Vehicle will begin on the Start Date stated on the first page of this Agreement and upon the issuance of the Warranty Authorization Number, the receipt of this signed Agreement and fulfillment of payment terms as agreed. Guarantee VC reserves the right to cancel this Agreement in the event of non-payment or if a payment plan is in place, such payments are not up-to-date and current. The Warranty Holder hereby certifies that the information contained in this Agreement is true and correct as of the Start Date stated on the first page of this Agreement. The Warranty Holder further certifies that the Covered Vehicle is in proper operating condition as of the Start Date stated on the front page of this Agreement. In the event that any information is determined incorrect or misleading, this Agreement shall be deemed void and any monies paid will be returned to the Warranty Holder, less an administration fee of $99.00.',
                    margin: [0, 5]
                },
                {
                    text: '2. Vehicle Eligibility:',
                    style: 'header',
                    margin: [0, 10, 0, 5],
                },
                {
                    ul: [
                        'The following vehicles are not eligible and are specifically excluded from all coverage under this Agreement, unless otherwise approved by Guarantee VC:',
                        '• Audi R8 (all other Audi Models are eligible); Ferrari; Aston Martin; Bentley; Bugatti; Lamborghini; Lexus LF4 (all other Lexus Models are eligible); Maserati; Maybach; Mercedes SLR and Mercedes SLS (all other Mercedes Models are eligible); Nissan GTR (all other Nissan models are eligible); Panoz; Rolls-Royce; Fisker Karma; McLaren; and Dodge Viper (all other Dodge Models are eligible);',
                        '• Any vehicles classified with a payload capacity of more than one (1) ton; or',
                        '• Vehicles used partially or exclusively for the following purposes: taxis, courier vehicles (including passenger vehicles used for courier use), chauffeured vehicles, Ride-hailing or Ride-Sharing Services (i.e Uber); delivery vehicles; snowplows or vehicles for which a snowplow is attached; tow-trucks; vehicles used for racing (professional or non-professional); police vehicles; ambulances and mobile canteens trucks;',
                        'Warranties on vehicles that fall under any of the above excluded categories will be cancelled and any monies received will be returned to the Warranty Holder, through the original selling dealership.'
                    ],
                    margin: [0, 5]
                },
                {
                    text: '3. Maintenance Requirements:',
                    style: 'header',
                    margin: [0, 10, 0, 5],
                },
                {
                    text: 'In order to maintain eligibility for coverage under this Agreement, the Warranty Holder must perform regularly scheduled maintenance, fluid changes on the Covered Vehicle according to the manufacturer’s requirements, including any special instructions (i.e. special oil, or increased frequency), for vehicles that have a high portion of short journeys (city driving) or operate in severe weather conditions. In all cases, an oil change interval cannot exceed 10,000 kilometres. Documentation to substantiate this maintenance from a licensed repair facility may be requested before a claim is approved. Guarantee VC reserves the right to refuse claims based on failure to perform the required maintenance services.',
                    margin: [0, 5]
                },
                {
                    text: '4. Components & Benefits of Coverage Mechanical Warranty Coverage:',
                    style: 'header',
                    margin: [0, 10, 0, 5],
                },
                {
                    text: 'According to the warranty plan chosen, as indicated on the first Page of this Agreement (and subject to full payment thereof), the Warranty Holder will receive the coverage indicated within the applicable sections of Section 7 below:\n\ni.) Essential Powertrain Plans: Includes components and benefits listed in Section A.',
                    margin: [0, 5]
                },
                {
                    text: '5. Maximum Liabilities:',
                    style: 'header',
                    margin: [0, 10, 0, 5],
                },
                {
                    text: 'The maximum liability undertaken by Guarantee VC hereunder shall not exceed,\ni.) $1000 per claim or half the purchase price of the vehicle whichever is less, and the total liability for the full term of coverage shall not exceed the full purchase price of the vehicle.',
                    margin: [0, 5]
                },
                {
                    text: '6. Deductible:',
                    style: 'header',
                    margin: [0, 10, 0, 5],
                },
                {
                    text: 'According to the front page of this document, all claims are subject to the payment of a deductible of $500.',
                    margin: [0, 5]
                },
                {
                    text: '7. Warranty Coverage:',
                    style: 'header',
                    margin: [0, 10, 0, 5],
                },
                {
                    text: 'Only the parts and labour described below (as applicable to your specific coverage selected and identified within Section 4 above) are covered (“covered part”) in the event of a Mechanical Failure or a Breakdown. Diagnostics are covered if the claim is validly covered by this Agreement (Maximum Diagnostic time deemed reasonable is one (1) hour). When reasonable, and at its sole discretion, Guarantee VC may authorize payment of fluids associated with a repair.',
                    margin: [0, 5]
                },
                {
                    text: 'The following shall be covered parts as outlined or limited herein:\n\n(A) provides coverage for:\n• Engine: Internally lubricated parts when damaged from within including but not limited to: Head gasket, engine block; cylinder heads; crankshaft and main bearings; crankshaft gears; connecting rods and bearings; camshaft and bearings; camshaft gears; push rods; pistons; rings and pins; intake and exhaust valves; valve springs and retainers; guides; lifters; rocker arm; shafts and pivots; harmonic balancer and pulley; timing chain; oil pump and shaft; ring gear, oil pan.\n• Turbocharger and Supercharger: Internally lubricated parts when damaged from within; including but not limited to: Housing; Wastegate actuator; Compressor valves.\n• Automatic Transmission: Internally lubricated parts when damaged from within including; but not limited to: torque converter; valve body; gear sets; main and intermediate shafts; clutches and bands; oil pump; flywheel; Ring gear.\n• Manual Transmission/Transaxle: Internally lubricated parts when damaged from within including but not limited to: Housing; Main and intermediate shafts; Gear sets; Synchronizer rings; Shifter fork; bearings.\n• Differential (front and rear): Internally lubricated parts when damaged from within including but not limited to: carrier gear and case; drive pinion and pinion gear; differential cover; bearings; mounts.\n• Transfer Case: Internally lubricated parts when damaged from within including but not limited to: housing; main shaft; gear group; sprocket and chain; bearings; shims.',
                    margin: [0, 5]
                },
                {
                    text: '8. How to make a claim:',
                    style: 'header',
                    margin: [0, 10, 0, 5],
                },
                {
                    ul: [
                        { text: 'In the event that repairs to the Covered Vehicle become necessary and covered by this Agreement:', margin: [0, 5] },
                        { text: 'The Warranty Holder must contact Guarantee VC at 1.800.268.3284 immediately to initiate the claim process.', margin: [0, 5] },
                        { text: 'The Covered Vehicle may be taken to any licensed mechanic of the Warranty Holder’s choice.', margin: [0, 5] },
                        { text: 'Guarantee VC reserves the right to refuse any repair estimate and/or has the right to request a second opinion at an alternative repair facility if a repair estimate is judged unreasonable.', margin: [0, 5] },
                        { text: 'Guarantee VC may request the Warranty Holder to produce documentation to substantiate maintenance requirements have been met as per Section 3 of this Agreement.', margin: [0, 5] },
                        { text: 'In some cases, claims adjusters will be required for onsite assessment(s).', margin: [0, 5] },
                        { text: 'The amounts paid by Guarantee V.C. for parts and labour are determined by the average similar repair costs or by the MITCHELL GUIDE or similar recognized repair manuals.', margin: [0, 5] },
                        { text: 'The liability of Guarantee VC under this warranty will extend only to repairs which have been duly authorized by Guarantee VC and up to the limits identified within Section 5.', margin: [0, 5] },
                        { text: 'Pre-Authorization is only granted when the Terms and Conditions set out in this Agreement have been met and this Agreement remains in force and the cost estimate is satisfactory to Guarantee VC.', margin: [0, 5] },
                        { text: 'A Claim Authorization Number is only valid for a period of thirty (30) days and only as applicable to the repair shop identified therein.', margin: [0, 5] },
                        { text: 'Guarantee V.C. may at its sole discretion replace failed parts with OEM, aftermarket, used or rebuilt parts.', margin: [0, 5] },
                        { text: 'If this Agreement expires, is cancelled or terminated by Guarantee VC (as permitted herein) prior to the work being completed, the repairs will not be covered by this Agreement.', margin: [0, 5] },
                        { text: 'Guarantee VC will pay repair costs directly to the mutually agreed upon licensed repair shop after a Claim Authorization Number is given in writing; after repairs are completed; after the final invoice is signed by the Warranty Holder and such is received by Guarantee VC.', margin: [0, 5] },
                        { text: 'The Registered Owner will only have to pay the deductible plus taxes, if applicable, and other miscellaneous non-covered items directly to the licensed mechanic.', margin: [0, 5] },
                        { text: 'In special circumstances only, Guarantee VC will reimburse the Warranty Holder for pre-authorized repairs.', margin: [0, 5] },
                        { text: 'The Warranty Holder will have to present Guarantee VC copies of the repair documents including the payment receipt within ten (10) days of paying for the repair to substantiate the reimbursement.', margin: [0, 5] },
                        { text: 'Any repair completed outside of the Province of Ontario will be evaluated as per the standards of the Ontario automobile industry.', margin: [0, 5] },
                        { text: 'All covered repair costs will be reimbursed in Canadian funds.', margin: [0, 5] },
                        { text: 'The Warranty Holder will have to present documents, including the payment receipt, to substantiate any rental allowance or trip interruption reimbursements, within ten (10) business days of paying for those services.', margin: [0, 5] },
                    ],
                },
                {
                    text: '9. Mechanical Warranty Coverage Exclusions:',
                    style: 'header',
                    margin: [0, 10, 0, 5],
                },
                {
                    ul: [
                        { text: 'The following are excluded from coverage under this Agreement:', margin: [0, 5] },
                        { text: 'a) All parts and labour not included in Part 6 of this document in accordance with the Warranty Plan indicated on the first page of this document;', margin: [0, 5] },
                        { text: 'b) Any mechanical defect judged to have existed prior to the Start Date for coverage as listed on the First Page of this Agreement;', margin: [0, 5] },
                        { text: 'c) Any repairs not authorized by Guarantee VC, or carried on at a location not authorized by Guarantee VC;', margin: [0, 5] },
                        { text: 'd) All parts and maintenance services described in the Covered Vehicle maintenance manual, including but not limited to: alignment; adjustments; software updates; wheel balancing; tune ups; spark plugs; spark plug wires; Supercharger isolator etc.;', margin: [0, 5] },
                        { text: 'e) Any electrical wiring repairs; hardware (nuts, bolts etc.); amplifier; glow plugs; hoses; seat belts; wiper blades; shop supplies; storage costs; hoist fees or cleaning materials; heated seats; rear backup cameras; weather stripping; windshield; Lumbar seat bladder; Oil filter housing; DEF lines; and/or drive belt pulley and idlers;', margin: [0, 5] },
                        { text: 'f) Mechanical Failure or Breakdown to the Covered Vehicle as a result of inadequate maintenance; abuse; misuse; or neglect or Mechanical Failure or Breakdown caused by a failure to adhere to the manufacturer’s required maintenance schedule;', margin: [0, 5] },
                        { text: 'g) Manual transmission clutch, throw out bearing, for solenoid or linkage;', margin: [0, 5] },
                        { text: 'h) Any Mechanical Failure or Breakdown due to an accumulation of dirty oil; carbonized or burnt valves; seized piston rings or an accumulation of carbon;', margin: [0, 5] },
                        { text: 'i) Any repair or replacement of a Covered Part, if a failure has not occurred (i.e. fraud) or if the wear on the part has not exceeded the field tolerances permitted by the manufacturer;', margin: [0, 5] },
                        { text: 'j) Any failure as a result of expired; contaminated; or improper fluids;', margin: [0, 5] },
                        { text: 'k) Any failure as a result of overheating or not maintaining proper levels of lubricants; fluids; refrigerants; or coolants including damage caused by failure of water hoses; radiators; or their connections; or in the transmission oil cooler lines;', margin: [0, 5] },
                        { text: 'l) Any failure caused to Covered Parts by the failure of non-covered parts;', margin: [0, 5] },
                        { text: 'm) The Covered Vehicle if it is in any way modified from its factory specifications;', margin: [0, 5] },
                        { text: 'n) Four wheel or rear wheel steering;', margin: [0, 5] },
                        { text: 'o) Any repairs where the only malfunction is high oil consumption and/or low compression;', margin: [0, 5] },
                        { text: 'p) Any failure caused to a Covered Part(s) by the breakdown of non-manufacturer installed parts;', margin: [0, 5] },
                        { text: 'q) Any failure of non-manufacturer installed parts;', margin: [0, 5] },
                        { text: 'r) Vehicles used to tow a trailer in excess of the limits recommended by the vehicle’s manufacturer;', margin: [0, 5] },
                        { text: 's) Any failure caused by unauthorized repair or teardown or parts inadequately installed;', margin: [0, 5] },
                        { text: 't) Any parts and repairs already covered by another Canadian or foreign warranty; including but not limited to a manufacturer or repairer’s warranty, or valid insurance policy of any kind;', margin: [0, 5] },
                        { text: 'u) All parts and repairs for which the manufacturer has announced its responsibility through any means including recall campaigns and factory service bulletins issued in the United States or Canada;', margin: [0, 5] },
                        { text: 'v) Any repairs subject to a class action lawsuit in the United States or Canada;', margin: [0, 5] },
                        { text: 'w) Vehicles with tampered or broken odometers;', margin: [0, 5] },
                        { text: 'x) Any Mechanical failure or Breakdown as a result of an accident; collision with another vehicle or road hazard; or falling objects;', margin: [0, 5] },
                        { text: 'y) Any Mechanical Failure or Breakdown caused or aggravated by the failure to properly protect the vehicle in the event or indication of failure to an operating part;', margin: [0, 5] },
                        { text: 'z) Any failure caused by fire; smoke; explosion; theft; vandalism; protests and riots; act of terrorism or nuclear contamination;', margin: [0, 5] },
                        { text: 'aa) Any Mechanical Failure or Breakdown caused by Acts of God; the weather; environment or a natural disaster; including but not limited to damage caused by water; flood; frost; condensation; lightning; earthquake; fierce winds; hail; rodents or other pests;', margin: [0, 5] },
                        { text: 'bb) Any deterioration or any failure caused by rust; corrosion or pitting;', margin: [0, 5] },
                        { text: 'cc) Guarantee V.C. is also not responsible for any liability for property damage; for injury to or death of any person arising out of the operation; maintenance or use of the vehicle whether or not related to the part(s) covered or following a repair made by a mechanic in an authorized repair shop;', margin: [0, 5] },
                        { text: 'dd) Guarantee V.C. is not responsible for any time loss; profit loss; inconvenience or any other loss that results from a failure; including delays in parts shipments or approving claims;', margin: [0, 5] },
                        { text: 'ee) Any suspicious noises coming from any parts or components that are in operation and do not affect any other parts or components;', margin: [0, 5] },
                    ],
                },

                {
                    text: 'III. GENERAL TERMS OF THE ENTIRE AGREEMENT',
                    style: 'header',
                    margin: [0, 10, 0, 5],
                },
                {
                    ol: [
                        {
                            text: 'Cancellations: This Agreement is non-cancellable except within ten (10) days of the purchase date of the coverage under this Agreement. During this period the Warranty Holder may cancel this Agreement through the selling dealer providing that no claims have been made. A cancellation fee of 25% of the sale price of the warranty (minimum of $100) plus taxes applies in all cases.',
                            margin: [0, 5],
                        },
                        {
                            text: 'OMVIC Compliance: This Agreement complies with the requirements under the new Motor Vehicle Dealers Act (MVDA). Surety is provided to Veri-Cheque Ltd, O/A “GVC Premium Warranty Company / Guarantee VC”, by Unica Insurance Inc.; 7150 Derrycrest Drive, Mississauga, ON, L5W 0E5.',
                            margin: [0, 5],
                        },
                        {
                            text: 'Transfer: This Agreement Can Not be transferred to another vehicle or subsequent owner of the named vehicle.',
                            margin: [0, 5],
                        },
                        {
                            text: 'Financial Agreements: If this Agreement’s coverage was financed either via a payment plan from Guarantee VC or through a third-party finance company, including an OEM credit arm (the “Funding Party”), the Funding Party shall be entitled to any refunds resulting from the cancellation of this Agreement for any reason, including but not limited to, repossession of the Covered Vehicle, total loss of the Covered Vehicle (including by way of theft). Failure to make monthly payments for this Agreement’s coverage in a timely manner may result in cancellation of this Agreement, under which no refund will be due and no claim will be approved.',
                            margin: [0, 5],
                        },
                        {
                            text: 'Right to Recover: If the Warranty Holder has a right to recover funds that Guarantee VC has paid under this Agreement against another party, the Warranty Holders rights against said third party shall become Guarantee VC’s rights. The Warranty Holder agrees to provide reasonable assistance to help Guarantee VC to recover these funds.',
                            margin: [0, 5],
                        },
                        {
                            text: 'Territory: This Agreement applies only to a Mechanical Failure or Breakdown that occurs and repairs made within Canada and the United States.',
                            margin: [0, 5],
                        },
                        {
                            text: 'Dispute Resolution: Most disputes or disagreements between Guarantee VC and the Warranty Holder arising under this Agreement can be resolved quickly by contacting Guarantee VC at the address noted on the first page of this Agreement. In the event Guarantee VC is unable to resolve a dispute with the Warranty Holder after attempting to do so informally, the parties to this Agreement agree to resolve such disputes through binding arbitration in accordance with the rules of the Canadian Arbitration Association. The party that intends to seek arbitration must first send to the other party, by certified mail, a written notice of dispute (“NOD”). The NOD should be addressed to the other party and contain (a) the nature and basis of the claim or dispute; and (b) set forth the specific relief sought. If the parties do not reach a settlement within thirty (30) days of receipt of the NOD, either party may commence an arbitration proceeding. Unless otherwise agreed to mutually by the parties, the arbitration process will take place in the Province of Ontario.',
                            margin: [0, 5],
                        },
                        {
                            text: 'Personal Information: The Warranty Holder hereby agrees that any personal information provided to Guarantee VC during the purchasing of this Agreement, the provision of a payment plan, processing and payment of claims hereunder, and/or the cancellation or transfer of this Agreement, is hereby consented to. Please note that Guarantee VC may use third party data storage providers outside of Canada and may also need to facilitate claims repairs outside Canada. The Warranty Holder hereby consents to the collection, use, storage and disclosure of their personal information for the purposes outlined herein.',
                            margin: [0, 5],
                        },
                        {
                            text: 'Entire Agreement: This Agreement constitutes the entire agreement between Guarantee VC and the Warranty Holder and supersedes and extinguishes all previous drafts, agreement, arrangement and understandings between them, whether written or oral, related to this subject matter.',
                            margin: [0, 5],
                        },
                        {
                            text: 'Governing Law: This Agreement shall be governed by the laws of the province of Ontario.',
                            margin: [0, 5],
                        },
                    ],
                },
           





            ]
        };

        // Generate the PDF and open it in a new tab
        pdfMake.createPdf(docDefinition).open();
    };
    


    const [dataList, setDataList] = useState(''); // Initialize with dummy data

    useEffect(() => {
        loadData();
    }, []);

    const warrantyData = [
        {
            "id": 1,
            "packages": 4,
            "packagesTypes": 0,
            "productIndex": 7,
            "productCost": "519",
            "packagesText": "Gap Financial Protection bundle",
            "productName": "GAP Financial Protection Bundle - Max Liability: $75,000 - Financed Amt: $0 - $75,000 (96 Months/unlimted)",
            "vinNo": "2589",
            "vinNoText": "2589",
            "make": "BMW",
            "makeText": "BMW",
            "model": "X1",
            "modelText": "X1",
            "year": 1998,
            "yearText": 1998,
            "odometer": "25000",
            "odometerText": "25000",
            "salePriceofVehicle": "5222",
            "salePriceofVehicleText": "5222",
            "comprehensiveFactoryWarrantyValid": "Yes",
            "comprehensiveFactoryWarrantyValidText": "Yes",
            "serviceDate": "2024-10-01",
            "serviceDateText": "2024-10-01",
            "warrantyClass": "Essential GCC",
            "warrantyClassText": "Essential GCC",
            "warrantyType": "Interior Shield",
            "warrantyTypeText": "Interior Shield",
            "warrantyProtection": "Extended",
            "warrantyProtectionText": "Extended",
            "warrantyOption": "1",
            "warrantyOptionText": "1",
            "highRatioCoverage": "Yes",
            "highRatioCoverageText": "Yes",
            "deductible": "$0 Deductible",
            "deductibleText": "$0 Deductible",
            "customerFirstName": "Manoj",
            "customerFirstNameText": "Manoj",
            "customerLastName": "Nayak",
            "customerLastNameText": "Nayak",
            "streetAddress": "kodila",
            "streetAddressText": "kodila",
            "town": "mangalore",
            "townText": "mangalore",
            "province": "British Columbia",
            "provinceText": "British Columbia",
            "postalCode": "857485",
            "postalCodeText": "857485",
            "customerPhone": "8574859685",
            "customerPhoneText": "8574859685",
            "customerEmail": "Abhi@gmail.com",
            "customerEmailText": "Abhi@gmail.com",
            "driverLicence": "78596",
            "driverLicenceText": "78596",
            "customerLanguage": "Francais",
            "customerLanguageText": "Francais",
            "dealNotes": "89655",
            "dealNotesText": "89655",
            "vinCust": "",
            "vinCustText": "",
            "salePriceofVehicleCust": "5222",
            "salePriceofVehicleCustText": "5222",
            "financeCompany": "mangalore",
            "financeCompanyText": "mangalore",
            "vehicleDeliveryDate": "2024-10-01",
            "vehicleDeliveryDateText": "2024-10-01",
            "warrantySoldFor": "966666666666666",
            "warrantySoldForText": "966666666666666"
        },
        {
            "id": 2, "packages": 4, "packagesTypes": 0, "productIndex": 3, "productCost": "519", "packagesText": "Gap Financial Protection bundle", "productName": "GAP Financial Protection Bundle - Max Liability: $75,000 - Financed Amt: $0 - $75,000 (96 Months/unlimted)",
            "vinNo": "258888888888", "vinNoText": "258888888888", "make": "Mercedes", "makeText": "Mercedes", "model": "C-Class", "modelText": "C-Class", "year": 2000, "yearText": 2000, "odometer": "25000", "odometerText": "25000", "salePriceofVehicle": "5222", "salePriceofVehicleText": "5222", "comprehensiveFactoryWarrantyValid": "No", "comprehensiveFactoryWarrantyValidText": "No", "serviceDate": "2024-10-01", "serviceDateText": "2024-10-01", "warrantyClass": "Appearnce Packages", "warrantyClassText": "Appearnce Packages", "warrantyType": "Rust Shield", "warrantyTypeText": "Rust Shield", "warrantyProtection": "Extended", "warrantyProtectionText": "Extended", "warrantyOption": "1", "warrantyOptionText": "1", "highRatioCoverage": "Yes", "highRatioCoverageText": "Yes", "deductible": "$0 Deductible", "deductibleText": "$0 Deductible", "customerFirstName": "Arun", "customerFirstNameText": "Arun", "language": "0", "languageText": "None", "customerLastName": "Nayak", "customerLastNameText": "Nayak", "streetAddress": "mysore", "streetAddressText": "mysore", "town": "mangalore", "townText": "mangalore", "province": "British Columbia", "provinceText": "British Columbia", "postalCode": "857485", "postalCodeText": "857485", "customerPhone": "89685748596", "customerPhoneText": "89685748596", "customerEmail": "arun@gmail.com", "customerEmailText": "arun@gmail.com", "driverLicence": "87458596", "driverLicenceText": "87458596", "customerLanguage": "Francais", "customerLanguageText": "Francais", "dealNotes": "87458555", "dealNotesText": "87458555", "vinCust": "258888888888", "vinCustText": "258888888888", "salePriceofVehicleCust": "5222", "salePriceofVehicleCustText": "5222", "financeCompany": "mangalore", "financeCompanyText": "mangalore", "vehicleDeliveryDate": "2024-10-02", "vehicleDeliveryDateText": "2024-10-02", "warrantySoldFor": "966666666666666", "warrantySoldForText": "966666666666666"
        }
    ]

    const loadData = async () => {
        try {
            const response = await axios.post(URL, { user });

            if (response.data.status === 401) {
                setDataList(""); // Keep dummy data in case of unauthorized response
            } else {
                console.log(response.data.data)
                const responseData = response.data.data;
                const dataWithIndex = response.data.data.map((item, index) => ({
                    ...item,
                    slNo: index + 1, // Assign sequential SL No starting from 1
                })) || "";
                setDataList(dataWithIndex);
            }
        } catch (err) {
            console.log("Error fetching data:", err);
            // Use dummy data if request fails
            setDataList('');
        }
    };

    const EditData = (props) => {
        return (
            <EditIcon style={{ cursor: "pointer" }} onClick={(e) => {
                e.stopPropagation();
                navigate('/BuildWarranty', { state: { type: "update", data: props.selectedRow } });

            }} />
        );
    }

    const DeleteData = (props) => {
        return (
            <DeleteIcon
                onClick={() => {
                    console.log(props.selectedRow.id);
                    // const data = {id:props.selectedRow.id};
                    // const mainURL = URL +'/'+data.id+ '/delete';
                    // serviceMethod(mainURL,data, handleSuccess, handleException);
                }}
            />
        );
    };

    const PrintData = (props) => {
        return (
            <PrintIcon
                style={{ cursor: "pointer" }} onClick={(e) => {
                    // e.stopPropagation();              
                    // navigate('/PDFGen', { state: { type: "update", data: props.selectedRow } });
                    generatePdf(props.selectedRow);
                }} />

        );
    };


    const handleSubmit = (e) => {
        navigate('/AddDealership', { state: { type: "add", value: "" } });
        // const method = "POST";
        // const data = { oldPassword: currentPassword, newPassword, email: user_email };
        // const mainURL = URL;
        // serviceMethod(mainURL, method, data, handleSuccess, handleException);
    }

    return (
        <div style={{ marginTop: "100px", padding: "0px" }}>
            <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
                <Toolbar />
                <Stack spacing={3}>
                    <Stack direction="row" spacing={3}>
                        <Stack spacing={1} sx={{ flex: '1 1 auto' }}>
                            {/* <Typography
                                variant="h6"
                                sx={{
                                    fontWeight: 'medium',
                                    color: 'darknavy',
                                    fontFamily: 'Montserrat, sans-serif',
                                    display: 'flex',        // Align items in a row
                                    alignItems: 'center',   // Vertically center the icon and text
                                }}
                            >
                                <TaskIcon sx={{ fontSize: '20px' }} /> &nbsp;Closed warranty
                            </Typography> */}
                            <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                                {/* <Button color="inherit" 
                            onClick={(e) => handleSubmit(e)}
                            sx={{
                                backgroundColor: 'purple',
                                color:'white',  // Change background color to purple
                                '&:hover': {
                                    backgroundColor: 'purple',  // Darken the color on hover
                                },
                            }}
                            
                            startIcon={<AddIcon fontSize="var(--icon-fontSize-md)" />}>
                                Add Dealership
                            </Button> */}
                                {/* <Button color="inherit" startIcon={<CloudDownloadIcon fontSize="var(--icon-fontSize-md)" />}>
                                Export
                            </Button> */}
                            </Stack>
                        </Stack>

                        <div>
                            {/* <Button startIcon={<AddIcon fontSize="var(--icon-fontSize-md)" />} variant="contained" onClick={toggleDrawer("right", true)}>
                                Add
                            </Button> */}
                        </div>
                    </Stack>
                </Stack>
                <br></br>
                {/* <Customer  toggleDrawer={toggleDrawer} state={state}  /> */}
                <DataGrid
                    rows={dataList}
                    columns={columns}
                    pageSize={5}
                    rowsPerPageOptions={[5]}
                    experimentalFeatures={{ newEditingApi: false }}
                    components={{
                        Toolbar: () => (
                            <Box
                                sx={{
                                    padding: 2,
                                    display: 'flex',
                                    justifyContent: 'flex-start', // Aligns to the left
                                    borderBottom: '0.2px solid grey', // Adds bottom border
                                }}
                            >
                                <Typography
                                    variant="h6"
                                    sx={{
                                        fontWeight: 'medium',
                                        // fontSize: '16px', // Use fontSize instead of font
                                        color: 'darknavy',
                                        fontFamily: 'Montserrat, sans-serif' // Ensure proper font family syntax
                                    }}
                                >
                                    Closed Warranty
                                </Typography>
                            </Box>
                        ),
                    }}
                    sx={{
                        '& .MuiDataGrid-columnHeaderTitle': {
                            color: 'darknavy',  // Set column header text color to dark navy blue
                            fontWeight: 'bold',  // Optional: Make column header text bold
                        }
                    }}
                />
            </Box>

        </div>
    );
}

export default ViewClosedWarranty;
